import STORE_CONST from '../consts'
import dashboardApi from '../../api/dashboard'

const state = {
  dashboard: {
    statistics: {},
    resourceTypes: [],
    operations: [],
    onlineMembers: [],
    onlineMembersCount: '',
    topMembers: [],
    topResources: []
  }
}

const mutations = {
  // get online connect list
  [STORE_CONST.DASHBOARD.LIST_ONLINE_CONNECT_COUNTS] (state, onlineMemberCount) {
    state.dashboard.onlineMembersCount = onlineMemberCount
  },
  // get online connect list
  [STORE_CONST.DASHBOARD.LIST_ONLINE_CONNECT] (state, onlineMemberList) {
    state.dashboard.onlineMembers = [...onlineMemberList]
  },
  // get statistics
  [STORE_CONST.DASHBOARD.GET_STATISTICS] (state, statistics) {
    state.dashboard.statistics = Object.assign({}, state.dashboard.statistics, statistics)
  },
  // get top members
  [STORE_CONST.DASHBOARD.LIST_TOP_MEMBERS] (state, topMembers) {
    state.dashboard.topMembers = topMembers
  },
  // get top resources
  [STORE_CONST.DASHBOARD.LIST_TOP_RESOURCES] (state, topResources) {
    state.dashboard.topResources = topResources
  }
}

const actions = {
  // 获取在线用户数量
  [STORE_CONST.DASHBOARD.LIST_ONLINE_CONNECT_COUNTS] ({ commit }, params) {
    return new Promise((resolve, reject) => {
      dashboardApi.getOnlineConnectCount(params).then(res => {
        commit(STORE_CONST.DASHBOARD.LIST_ONLINE_CONNECT_COUNTS, res.data.count)
        resolve(res.data)
      }, (err) => {
        reject(err)
      })
    })
  },
  // get online connect list
  [STORE_CONST.DASHBOARD.LIST_ONLINE_CONNECT] ({ commit }, params) {
    return new Promise((resolve, reject) => {
      dashboardApi.getOnlineConnectList(params).then(res => {
        commit(STORE_CONST.DASHBOARD.LIST_ONLINE_CONNECT, res.data.objects)
        resolve(res.data.objects)
      }, (err) => {
        reject(err)
      })
    })
  },
  [STORE_CONST.DASHBOARD.GET_ONLINE_CONNECT] ({ commit }, params) {
    return new Promise((resolve, reject) => {
      dashboardApi.getOnlineConnectList(params).then(res => {
        resolve(res.data.objects)
      }, (err) => {
        reject(err)
      })
    })
  },
  [STORE_CONST.DASHBOARD.GET_STATISTICS] ({ commit }, params) {
    return new Promise((resolve, reject) => {
      dashboardApi.getStatistics(STORE_CONST.DASHBOARD.GET_STATISTICS).then(res => {
        commit(STORE_CONST.DASHBOARD.GET_STATISTICS, res.data)
        resolve(res.data)
      }, (err) => {
        reject(err)
      })
    })
  },
  // get top members
  [STORE_CONST.DASHBOARD.LIST_TOP_MEMBERS] ({ commit }, params) {
    return new Promise((resolve, reject) => {
      dashboardApi.getTopMembers(params).then(res => {
        // commit(STORE_CONST.DASHBOARD.LIST_TOP_MEMBERS, res.data.result)
        resolve(res.data.result)
      }, (err) => {
        reject(err)
      })
    })
  },
  // get top resources
  [STORE_CONST.DASHBOARD.LIST_TOP_RESOURCES] ({ commit }, params) {
    return new Promise((resolve, reject) => {
      dashboardApi.getTopResources(params).then(res => {
        // commit(STORE_CONST.DASHBOARD.LIST_TOP_RESOURCES, res.data.result)
        resolve(res.data.result)
      }, (err) => {
        reject(err)
      })
    })
  },
  // cut online connect
  [STORE_CONST.DASHBOARD.CUT_ONLINE] ({ commit }, id) {
    return new Promise((resolve, reject) => {
      dashboardApi.cutOnlineConnent(id).then(res => {
        resolve(res.data)
      }, (err) => {
        reject(err)
      })
    })
  },
  // cut online connect multiple
  [STORE_CONST.DASHBOARD.CUT_ONLINE_MULTIPLE] ({ commit }, id) {
    return new Promise((resolve, reject) => {
      dashboardApi.cutOnlineConnentMultiple(id).then(res => {
        resolve(res.data)
      }, (err) => {
        reject(err)
      })
    })
  },
  [STORE_CONST.DASHBOARD.GET_CONNECT_NUMBER] ({ commit }, params) {
    return new Promise((resolve, reject) => {
      dashboardApi.getConnectNumbers(params).then(res => {
        resolve(res.data)
      }, (err) => {
        reject(err)
      })
    })
  },
  [STORE_CONST.DASHBOARD.GET_OPERATION_WEEK] ({ commit }, params) {
    return new Promise((resolve, reject) => {
      dashboardApi.getWeekOperationStatistic(params).then(res => {
        resolve(res.data.result)
      }, (err) => {
        reject(err)
      })
    })
  },
  [STORE_CONST.DASHBOARD.GET_RESOURCE_TYPE_STATISTIC] ({ commit }, params) {
    return new Promise((resolve, reject) => {
      dashboardApi.getResourceTypeStatistic(params).then(res => {
        resolve(res.data)
      }, (err) => {
        reject(err)
      })
    })
  },
  [STORE_CONST.DASHBOARD.GET_STATISTIC_SUMMARY] ({ commit }, params) {
    return new Promise((resolve, reject) => {
      dashboardApi.getStatisticSummary(params).then(res => {
        resolve(res.data)
      }, (err) => {
        reject(err)
      })
    })
  },
}

const getters = {
  dashboard: state => {
    return state.dashboard
  }
}

export default {
  state,
  mutations,
  actions,
  getters
}



// WEBPACK FOOTER //
// ./src/store/modules/dashboard.js